import Kernel from './Kernel';

export class Mmenu extends Kernel {
    constructor (target) {
        if (process.env.DEBUG)
        {
            console.log('%cModule: Menu has been loaded', 'color: green;');
        }

        super(target);

        this.$toggle = $('.js-menu-toggle');

        this.listeners();
    }

    listeners () {

        this.$toggle.on('click', () => {
            this.$html.toggleClass('menu-is-open');
        });
    }

    destroy () {
        if (process.env.DEBUG)
        {
            console.log('%cModule: Menu has been destroyed', 'color: red;');
        }
        this.$toggle.off();
    }
}

export default Mmenu;



// WEBPACK FOOTER //
// ./app/src/js/modules/Mmenu.js